import router from '@/router';

const OCRoutes = [
  {
    path: 'user/shiploads',
    name: 'UserShipload',
    component: {
      name: 'UserShipload',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'shipload',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserShiploadIndex',
        component: () => import('../views/user/ShiploadIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'UserShiploadNew',
        component: () => import('../views/user/ShiploadInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'UserShiploadIndex' },
        },
      },
      {
        path: 'new/nor',
        name: 'nor',
        component: () => import('../views/user/NoticeOfReadinessInput.vue'),
        meta: {
          action: 'new',
          customName: 'views.shipload.shipload_new_nor.new.title',
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserShiploadShow',
        component: () => import('../views/user/ShiploadShow.vue'),
        meta: {
          backRoute: {
            name: 'UserShiploadIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserShiploadDetails',
            component: () => import('../views/user/ShiploadDetails.vue'),
            meta: {
              backRoute: { name: 'UserShiploadIndex' },
            },
          },
          {
            path: 'edit',
            name: 'UserShiploadEdit',
            component: () => import('../views/user/ShiploadInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'UserShiploadDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'UserShiploadAttachments',
            component: () => import('../views/user/attachment/ShiploadAttachments.vue'),
            meta: {
              backRoute: { name: 'UserShiploadIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'UserShiploadAttachmentsEdit',
            component: () => import('../views/user/attachment/ShiploadAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'UserShiploadAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'shipload_events',
            name: 'UserShiploadShiploadEvents',
            component: () => import('../views/user/shiploadEvent/ShiploadShiploadEvents.vue'),
            meta: {
              backRoute: { name: 'UserShiploadIndex' },
              resource: 'shipload_event',
              customName: 'views.shipload.statement_of_facts',
            },
          },
        ],
      }
    ],
  },
  {
    path: 'user/shiploads_planning',
    name: 'UserShiploadPlanning',
    component: {
      name: 'UserShipload',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'shipload',
      customName: 'views.shipload.shiploads_planning_overview.index.title',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserShiploadsPlanning',
        component: () => import('../views/user/ShiploadPlanning.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));